import { IWorkItem } from '../../store/typings';

export function getActionTileData(actions: IWorkItem[]) {
  const result: { id: any; name: any; count: any; url: string }[] = [];
  const stateMap = new Map();
  actions.forEach((item) => {
    const state = item.Fields['System.State'];
    if (stateMap.has(state)) {
      stateMap.set(state, stateMap.get(state) + 1);
    } else {
      stateMap.set(state, 1);
    }
  });

  stateMap.forEach((value, key) => {
    result.push({ id: key, name: key, count: value, url: '' });
  });

  return result;
}
